import script from "./ClientImagesPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientImagesPicker.vue?vue&type=script&setup=true&lang=js"

import "./ClientImagesPicker.vue?vue&type=style&index=0&id=4e5acd80&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e5acd80"]])

export default __exports__